module.exports = __webpack_public_path__ + "static/media/clientPhoto6.fce207d7.png";